<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
      <!-- 弹窗队列 -->
      <modal-list></modal-list>
    </div>

  </a-config-provider>
</template>

<script>
import { mapActions } from 'vuex'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { AppDeviceEnquire } from '@/utils/mixin'
import modalList from '@/components/Zpace/modal/modalList'

export default {
  mixins: [AppDeviceEnquire],
  data () {
    return {
      locale: zhCN
    }
  },
  components: {
    modalList
  },
  computed: {
  },
  methods: {

  },
  created () {

  },
  watch: {
  }
}
</script>
<style lang="less" >

  #app {
    height: 100%;

  }
</style>
